import { action, observable, makeObservable } from 'mobx';

export interface IAccessToken {
    id: string;
    created?: Date;
    ttl?: number;
}

export class AccessTokenStore {
    accessToken: IAccessToken = { id: '' };

    constructor(accessToken: IAccessToken) {
        makeObservable(this, {
            accessToken: observable,
            update: action
        });

        this.update(accessToken);
    }

    update(accessToken: IAccessToken): void {
        this.accessToken = {
            ...this.accessToken,
            ...accessToken
        };
    }
}
